import type { TableColumnsWeight } from '@/domains/productDiscovery/ProductPage/common/components/Attributes/Attributes';

export interface AttributesTableSettings {
  maxRowsDisplayed: number;
  columnsWeight: TableColumnsWeight;
}

export const settings: AttributesTableSettings = {
  maxRowsDisplayed: 10,
  columnsWeight: {
    name: 'semiBold',
    value: 'regular',
  },
};
